import { TOKEN_INFO } from '@core/constants/generic.constant';
import { AuthLogin, AuthTokenModel, IResetPasswordBody } from '@core/models/auth.model';
import { AxiosResponse } from 'axios';
import Cookies from 'js-cookie';
import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class AuthService {
    private readonly loginURL = `/auth_admin/login`;

    private readonly refreshURL = `/auth/refresh`;

    private readonly logoutURL = `/auth/logout`;

    private readonly resendOtpURL = `/authVerificationCode/resend`;

    private readonly setOtpURL = `/authVerificationCode/set`;

    private readonly forgetPasswordURL = `/auth/forgot-password`;

    private readonly resetPasswordURL = `/auth/reset-password`;

    private readonly endSessionURL = `/authVerificationCode/end-session`;
    // ---------------------------------------------------------------

    login(body: AuthLogin) {
        return fetchWithRetry(API.post(this.loginURL, body));
    }
    // ---------------------------------------------------------------
    setOTP(token: string, code: string) {
        return fetchWithRetry(
            API.post(
                this.setOtpURL,
                {
                    code: code,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
        );
    }
    endSession(token: string) {
        return fetchWithRetry(
            API.post(
                this.endSessionURL,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
        );
    }

    resetPassword(body: IResetPasswordBody) {
        return fetchWithRetry(API.post(this.resetPasswordURL, body));
    }

    resendOTP(token: string) {
        return fetchWithRetry(
            API.post(
                this.resendOtpURL,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
        );
    }

    getTokenInfo(): AuthTokenModel {
        const tokenInfo = Cookies.get(TOKEN_INFO) || `{}`;
        return JSON.parse(tokenInfo as string);
    }

    refresh(): Promise<AxiosResponse<any>> {
        return fetchWithRetry(
            API.post(
                this.refreshURL,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${this.getTokenInfo().refresh_token}`,
                    },
                }
            )
        );
    }

    forgetPassword(email: string) {
        return fetchWithRetry(API.post(this.forgetPasswordURL, { email }));
    }
    // ----------------------------------------------------------------
    logout() {
        return fetchWithRetry(API.post(this.logoutURL));
    }
}

export default new AuthService();
